import React from 'react'
import ConnectButton from './ConnectButton'
import ContactUsButton from './ContactUsButton'
import ProviderRowBase, {} from './ProviderRowBase'











const ProviderRowContactUs = (props) => {
  const {contactUsUrl, onContactUsSubmit, onConnectClick, submitting, hasProvider, ...other} = props

  const connectButton = !hasProvider ? (
    React.createElement(ContactUsButton, { contactUsUrl: contactUsUrl, onContactUsSubmit: onContactUsSubmit,} )
  ) : (
    React.createElement(ConnectButton, { onConnectClick: onConnectClick, submitting: submitting,} )
  )

  return React.createElement(ProviderRowBase, { ...other, connectButton: connectButton,} )
}

export default ProviderRowContactUs
